export default __webpack_public_path__ + "static/media/booking.c18aefb6.svg";